import { stageView } from '@microsoft/teams-js';
import { getMetaOsHubContextThrows } from '@ms/yammer-web-support/dist/metaOsHub';
import type { NonOptionalTeamsContext, TeamsContext, TeamsThemeType } from 'state/teamsContext';

export { MetaOsHubNotFoundError } from '@ms/yammer-web-support/dist/metaOsHub';

const supportedThemes: TeamsThemeType[] = ['default', 'dark', 'contrast'];
const isThemeSupported = (theme: string): theme is TeamsThemeType => (supportedThemes as string[]).includes(theme);

type GetSupportedTheme = (theme: string | undefined) => TeamsThemeType;
const getSupportedTheme: GetSupportedTheme = (theme) => (theme && isThemeSupported(theme) ? theme : 'default');

type GetContextFromMetaOsHub = () => Promise<NonOptionalTeamsContext>;
const getContextFromMetaOsHub: GetContextFromMetaOsHub = async () => {
  const { app, page, user, chat } = await getMetaOsHubContextThrows();

  return {
    appSessionId: app.sessionId,
    appLaunchId: app.appLaunchId,
    manifestVersion: app.manifestVersion,
    chatId: chat?.id,
    deepLinkPath: undefined,
    entityId: page.id,
    hostClientType: app.host.clientType,
    hostAppName: app.host.name,
    locale: app.locale,
    ringId: app.host.ringId,
    sessionId: app.host.sessionId,
    subEntityId: page.subPageId,
    theme: getSupportedTheme(app.theme),
    userClickTime: app.userClickTime,
    isBackgroundLoad: page.isBackgroundLoad,
    userId: user?.id,
    tenantId: user?.tenant?.id,
    loginHint: user?.loginHint,
    isMultiWindow: !!page.isMultiWindow && stageView.isSupported(),
  };
};

type GetContext = () => Promise<TeamsContext>;
export const getContext: GetContext = async () => getContextFromMetaOsHub();
